import React from 'react';
import FormRoomType from './FormRoomType/FormRoomType';
// import styles from './UpsertRoomType.styles';

export default function UpsertRoomType() {
  return <FormRoomType />;
}
